export default __webpack_public_path__ + "static/media/check-circle-dark.479c63aa.svg";